import React from 'react';
import { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';
import { Button } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import UserPagesList from './UserPagesList';

export interface IUserPagesSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  items?: InkindPageAPIModel[];
}

const blockName = 'user-pages-section';

export default function UserPagesSection({ ...otherProps }: IUserPagesSectionProps) {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  return (
    <div className={bem()} {...otherProps}>
      <section className={bem('header')}>
        <div className={bem('header-text')}>{t(translationKeys.title)}</div>
        <Button type="a" externalLink href="/create" variant="secondary">
          {t(translationKeys.btnCreateNewPage)}
        </Button>
      </section>
      <section className={bem('about')}>
        <p className={bem('about-text')}>
          Pages you&apos;ve created, organize, or have chosen to follow appear here. Pages you organize have an{' '}
          <strong style={{ color: 'orange' }}>orange</strong> border.
        </p>
      </section>

      <UserPagesList />
    </div>
  );
}
